var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Overview",
    transform: "translate(-46 -43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8622",
    "data-name": "Rectangle 8622",
    width: 38,
    height: 38,
    rx: 19,
    transform: "translate(46 43)",
    fill: "#404246"
  }), /*#__PURE__*/React.createElement("g", {
    id: "list",
    transform: "translate(-23.912 -39.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17156",
    "data-name": "Group 17156",
    transform: "translate(79.957 95.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30456",
    "data-name": "Path 30456",
    d: "M81.19,108.5a1.233,1.233,0,1,1,1.233-1.234A1.233,1.233,0,0,1,81.19,108.5Zm0-5.25a1.234,1.234,0,1,1,1.233-1.234A1.233,1.233,0,0,1,81.19,103.25Zm0-5.25a1.233,1.233,0,1,1,1.233-1.234A1.233,1.233,0,0,1,81.19,98Zm15.443,10.423H85.069a1.235,1.235,0,1,1,0-2.47H96.633a1.235,1.235,0,1,1,0,2.47Zm0-5.21H85.069a1.235,1.235,0,1,1,0-2.47H96.633a1.235,1.235,0,1,1,0,2.47Zm0-5.21H85.069a1.235,1.235,0,1,1,0-2.47H96.633a1.235,1.235,0,1,1,0,2.47Z",
    transform: "translate(-79.957 -95.533)",
    fill: "#f8f8f8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.822ac93c5af28add7ef23a97b29bec4e.svg";
export { ForwardRef as ReactComponent };